const spotlightItems = [
  {
    tag: '韩漫推荐',
    title: '社长大人是禽兽',
    desc: '办公室恋情 × 霸道总裁，高人气韩漫持续连载中，每周五更新！细腻画风与紧凑剧情让人欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20businessman%20in%20a%20modern%20office%20setting%20with%20romantic%20atmosphere%2C%20warm%20lighting%20through%20large%20windows%2C%20elegant%20suit%2C%20soft%20color%20palette%2C%20artistic%20webtoon%20aesthetic%2C%20clean%20composition%2C%20professional%20illustration%20quality&width=800&height=500&seq=carousel-01-kr&orientation=landscape',
  },
  {
    tag: '日漫精选',
    title: '咒术回战·涩谷事变',
    desc: '现象级热血日漫，超强战斗场面与深刻人物刻画，单行本销量突破千万！动画同步热播中。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20style%20action%20scene%20with%20intense%20battle%20poses%2C%20urban%20night%20setting%20with%20dramatic%20lighting%2C%20flowing%20energy%20effects%2C%20detailed%20character%20design%2C%20anime%20art%20aesthetic%2C%20vibrant%20color%20accents%20on%20dark%20background%2C%20cinematic%20composition&width=800&height=500&seq=carousel-02-jp&orientation=landscape',
  },
  {
    tag: '国漫专区',
    title: '一人之下·天师下山',
    desc: '国产漫画标杆之作，融合道家文化与现代都市异能，独特世界观构建令人叹为观止。',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20blending%20traditional%20Taoist%20elements%20with%20modern%20urban%20setting%2C%20martial%20arts%20character%20in%20flowing%20robes%2C%20mystical%20energy%20visualization%2C%20ancient%20temples%20against%20city%20skyline%2C%20rich%20cultural%20aesthetic%2C%20detailed%20ink%20brush%20style%2C%20dramatic%20composition&width=800&height=500&seq=carousel-03-cn&orientation=landscape',
  },
  {
    tag: '热门连载',
    title: '我独自升级·第二季',
    desc: '全球爆款韩漫续作！S级猎人觉醒之旅，画风炸裂，每一话都是视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20style%20illustration%20of%20a%20powerful%20hunter%20character%20with%20glowing%20energy%20aura%2C%20dark%20dungeon%20background%20with%20mysterious%20light%20sources%2C%20epic%20fantasy%20atmosphere%2C%20detailed%20armor%20design%2C%20dramatic%20dynamic%20pose%2C%20high%20contrast%20lighting%2C%20professional%20manhwa%20art&width=800&height=500&seq=carousel-04-solo&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">焦点推荐</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精选的热门作品，皮皮漫画韩漫、日漫与国漫焦点一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {spotlightItems.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row h-full">
                <div className="relative w-full sm:w-[220px] md:w-[260px] h-[200px] sm:h-auto shrink-0 overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium w-fit mb-3 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
                  <a
                    href="#"
                    className="inline-flex items-center gap-1.5 mt-4 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    立即阅读
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}